import * as React from "react";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  ToggleIconLeft,
  SortIcon,
  DropdownDots,
  RemoveTag,
} from "../../../../components/ui/icons";
import EditOrgAdmin from "../../../../components/modals/editOrgAdmin";
import EnableDisablePopup from "./enableDisablePopup";
import OrganizationSummaryModal from "./organizationSummaryModal";
import DeleteOrganizationModal from "./deleteOrganization";
import EnableDisablePublicApi from "./enableDisablePublicAPI";
import LicensingModal from "../../../../components/modals/licensingModal";
const OrganizationsColumns = (
  navigate,
  handleFirmwareRowSelection,
  handleIotAgentRowSelection,
  handleReinvite,
  handleViewRowSelection,
  handleAssignTemplates,
) => {
  return [
    {
      accessorFn: (row) => row.organizationDetails.displayName,
      id: "displayName",
      header: (row) => (
        <div className="table-heading">
          Organization Name{" "}
          <span>
            <SortIcon />
          </span>
        </div>
      ),
      cell: (info) => info.getValue(),
      enableColumnFilter: false,
      footer: (props) => props.column.id,
    },
    {
      accessorFn: (row) => row.organizationDetails.name || "",
      id: "adminName",
      header: (row) => (
        <div className="table-heading">
          Admin Name{" "}
          <span>
            <SortIcon />
          </span>
        </div>
      ),
      cell: (row) => row.getValue(),
      footer: (props) => props.column.id,
      enableColumnFilter: false,
    },
    {
      accessorFn: (row) => row.organizationDetails.address,
      id: "address",
      header: (row) => (
        <div className="table-heading">
          Address{" "}
          <span>
            <SortIcon />
          </span>
        </div>
      ),
      cell: (row) => row.getValue(),
      footer: (props) => props.column.id,
      enableColumnFilter: false,
    },
    {
      accessorFn: (row) => row.organizationDetails.phoneNo,
      id: "phoneNo",
      header: (row) => (
        <div className="table-heading">
          Contact{" "}
          <span>
            <SortIcon />
          </span>
        </div>
      ),
      cell: (row) => row.getValue(),
      footer: (props) => props.column.id,
      enableColumnFilter: false,
    },
    {
      accessorFn: (row) => row.organizationDetails.status,
      id: "status",
      header: (row) => (
        <div className="table-heading">
          Status{" "}
          <span>
            <SortIcon />
          </span>
        </div>
      ),
      cell: (row) => row.getValue(),
      footer: (props) => props.column.id,
      enableColumnFilter: false,
    },
    {
      accessorFn: (row) => row.iotVersion,
      id: "iotVersion",
      header: (row) => (
        <div className="table-heading">
          Iot Agent Version{" "}
          <span>
            <SortIcon />
          </span>
        </div>
      ),
      cell: (row) => {
        const value = row.getValue();
        const orgDetails = row.row.original;
        const isOrgActive: boolean =
          row.row.original.organizationDetails.status === "Active";
        return (
          <div className="table-cell">
            <div>
              {value && isOrgActive && (
                <>
                  <OrganizationSummaryModal
                    orgDetails={orgDetails}
                    firmware={false}
                  />
                  <span style={{ marginLeft: "2rem" }}>{value}</span>
                </>
              )}
              {!value && isOrgActive && (
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-no-devices-${row.id}`}>
                      No Devices available
                    </Tooltip>
                  }
                >
                  <span style={{ marginLeft: "2rem" }}>
                    <RemoveTag />
                  </span>
                </OverlayTrigger>
              )}
            </div>
          </div>
        );
      },
      footer: (props) => props.column.id,
      enableColumnFilter: false,
    },
    {
      accessorFn: (row) => row.firmwareVersion,
      id: "firmwareVersion",
      header: (row) => (
        <div className="table-heading">
          Firmware Version{" "}
          <span>
            <SortIcon />
          </span>
        </div>
      ),
      cell: (row) => {
        const value = row.getValue();
        const orgDetails = row.row.original;
        const isOrgActive: boolean =
          row.row.original.organizationDetails.status === "Active";
        return (
          <div className="table-cell">
            <div>
              {value && isOrgActive && (
                <>
                  <OrganizationSummaryModal
                    orgDetails={orgDetails}
                    firmware={true}
                  />
                  <span style={{ marginLeft: "2rem" }}>{value}</span>
                </>
              )}
              {!value && isOrgActive && (
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-no-devices-${row.id}`}>
                      No Devices available
                    </Tooltip>
                  }
                >
                  <span style={{ marginLeft: "2rem" }}>
                    <RemoveTag />
                  </span>
                </OverlayTrigger>
              )}
            </div>
          </div>
        );
      },
      footer: (props) => props.column.id,
      enableColumnFilter: false,
    },
    {
      accessorFn: (row) => row.organizationDetails.isSuperAdminApproved,
      id: "publicApiAccess",
      header: () => (
        <div
          className="table-heading text-center"
          style={{ width: "100px", maxWidth: "100px", whiteSpace: "nowrap" }}
        >
          Public API Access{" "}
          <span>
            <SortIcon />
          </span>
        </div>
      ),
      cell: ({ row }) => {
        const email = row.original.organizationDetails.email;
        const orgDisplayName = row.original.organizationDetails.displayName;
        const orgId = row.original.organizationDetails.orgId;
        const isApproved =
          row.original.organizationDetails.isSuperAdminApproved;
        return (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              width: "100px",
              maxWidth: "100px",
              padding: 0,
            }}
          >
            <EnableDisablePublicApi
              email={email}
              orgId={orgId}
              displayName={orgDisplayName}
              isApproved={isApproved}
            />
          </div>
        );
      },
      size: 100,
      maxSize: 100,
      enableColumnFilter: false,
      sortingFn: "basic",
    },

    {
      accessorKey: "visits",
      header: () => <span></span>,
      Cell: () => <ToggleIconLeft />,
      footer: (props) => props.column.id,
      enableColumnFilter: false,
      cell: (row) => {
        const isOrgInvited: boolean =
          row.row.original.organizationDetails.status === "Invited";
        const isOrganizationDeletable =
          row.row.original.totalIotDevices +
            row.row.original.totalFirmwareDevices ==
          0
            ? true
            : false;
        return (
          <div className="actions-btns">
            <Dropdown>
              <Dropdown.Toggle id="dropdowndots">
                <DropdownDots />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {!isOrgInvited && (
                  <Dropdown.Item href="">
                    <EditOrgAdmin
                      orgId={row.row.original.organizationDetails.orgId}
                      email={row.row.original.organizationDetails.email}
                      phoneNo={row.row.original.organizationDetails.phoneNo}
                      orgName={row.row.original.organizationDetails.displayName}
                      address={row.row.original.organizationDetails.address}
                    />
                  </Dropdown.Item>
                )}
                {!isOrgInvited && (
                  <Dropdown.Item href="">
                    <EnableDisablePopup
                      orgAdminName={row.row.original.organizationDetails.name}
                      orgName={row.row.original.organizationDetails.displayName}
                      isEnabled={
                        row.row.original.organizationDetails.status.toLowerCase() ===
                        "active"
                      }
                    />
                  </Dropdown.Item>
                )}
                {!isOrgInvited && (
                  <Dropdown.Item>
                    <div
                      onClick={() =>
                        handleViewRowSelection(
                          row.row.original.organizationDetails.displayName,
                          row.row.original.organizationDetails.orgId,
                        )
                      }
                    >
                      {" "}
                      View
                    </div>
                  </Dropdown.Item>
                )}
                {!isOrgInvited && (
                  <Dropdown.Item>
                    <LicensingModal
                      orgId={row.row.original.organizationDetails.orgId}
                      orgName={row.row.original.organizationDetails.displayName}
                    ></LicensingModal>
                  </Dropdown.Item>
                )}
                {!isOrgInvited && (
                  <Dropdown.Item>
                    <div
                      onClick={() =>
                        handleAssignTemplates(
                          row.row.original.organizationDetails.orgId,
                        )
                      }
                    >
                      Assign Templates
                    </div>
                  </Dropdown.Item>
                )}
                {!isOrgInvited && (
                  <Dropdown.Item>
                    <div>
                      <button
                        disabled={row.row.original.totalIotDevices == 0}
                        onClick={() =>
                          handleFirmwareRowSelection(row.row.original.orgId)
                        }
                      >
                        Update Firmware
                      </button>
                    </div>
                  </Dropdown.Item>
                )}
                {!isOrgInvited && (
                  <Dropdown.Item>
                    <div>
                      <button
                        disabled={row.row.original.totalIotDevices == 0}
                        onClick={() =>
                          handleIotAgentRowSelection(row.row.original.orgId)
                        }
                      >
                        Update IOT Agent
                      </button>
                    </div>
                  </Dropdown.Item>
                )}
                {isOrgInvited && (
                  <Dropdown.Item>
                    <div
                      onClick={() =>
                        handleReinvite(
                          row.row.original.organizationDetails.displayName,
                          row.row.original.organizationDetails.email,
                        )
                      }
                    >
                      <span>Re-Invite</span>
                    </div>
                  </Dropdown.Item>
                )}
                {isOrganizationDeletable && (
                  <Dropdown.Item>
                    <DeleteOrganizationModal
                      orgName={row.row.original.organizationDetails.displayName}
                      orgId={row.row.original.organizationDetails.orgId}
                    ></DeleteOrganizationModal>
                  </Dropdown.Item>
                )}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        );
      },
    },
  ];
};

export default OrganizationsColumns;
